export default __webpack_public_path__ + "static/applet-11-set-1-41a845d85c129c2afc210a002745b2d5.webp";